import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FwLayoutsModule, FwPopoverModule, FwCardModule, FwAvatarModule, FwBadgeModule, FwChipModule, FwProgressModule } from '@flywheel-io/vision';
import { AnnotationCardComponent } from './annotation-card/annotation-card.component';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { AnnotationQueryService } from './annotation.service';

@Component({
  selector: 'app-annotation-list',
  standalone: true,
  imports: [
    FwPopoverModule,
    FwLayoutsModule,
    FwCardModule,
    FwAvatarModule,
    FwBadgeModule,
    FwChipModule,
    FwProgressModule,
    AnnotationCardComponent,
],
  templateUrl: './annotation-list.component.html',
  styleUrl: './annotation-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnotationListComponent {

  annotationsService = inject(AnnotationQueryService);

  fileId = input<string>();
  annotationsQuery = injectQuery(() => this.annotationsService.byFile(this.fileId))
  annotations = this.annotationsQuery.data;
}
